<template>
  <div id="app">
    <!-- <Navbar :isFirst="'true'" id="d1" v-bind:class="{white:!d1}"></Navbar> -->
    <Navbar></Navbar>
    <div class="pheader">
      <div class="section_header" >
        <div class="phone-logo" @click="phonelogo()"></div>
        <div class="phone-bar" @click="off1()"></div>
      </div>
      <!-- v-bind:class="{push:off}" -->
      <div class="closes" v-bind:class="{push:$store.state.d5}" ref="divup">
          <div class="close" @click="off2()"><img src="./assets/phone/close.svg" alt=""></div>
          <ul class="nav1">
            <li @click="clickHome()"><div class="menu">
              <div class="write"><a>首页</a></div>
              <div class="icon"></div>
            </div></li>
            <li @click="hardPro()"><div class="menu">
                <div class="write"><a :class="{active:isActive}">硬件产品</a></div>
                <div class="icon" v-show="showone"></div>
                <div class="icon1" v-show="showtwo"></div>
              </div>
            </li>
            <div class="twohard" v-show="showtwo">
              <li @click="clickHardone()"><div class="menu">
                <div class="write"><a>　经典维码器</a></div>
                <div class="icon"></div>
                </div>
              </li>
              <li @click="clickHardtwo()"><div class="menu">
                <div class="write"><a>　智能投币器</a></div>
                <div class="icon"></div>
                </div>
              </li>
            </div>
            <li @click="clickSoft()"><div class="menu">
                <div class="write"><a>软件服务</a></div>
                <div class="icon"></div>
              </div></li>
            <li @click="clickCase()"><div class="menu">
                <div class="write"><a>合作案例</a></div>
                <div class="icon"></div>
              </div></li>
            <li @click="clickAbout()"><div class="menu">
                <div class="write"><a>关于我们</a></div>
                <div class="icon"></div>
              </div></li>
            <li @click="clickLog()"><div class="menu">
                <div class="write"><a>后台登录</a></div>
                <div class="icon"></div>
              </div></li>
            <li @click="clickEgVersion('https://www.weimaqi.net/en/admin_m/login.html')">
              <div class="menu">
                <div class="write"><a>English version</a></div>
                <div class="icon"></div>
              </div></li>
        </ul>
      </div>
    </div>
  
    <router-view></router-view> 
    
  </div>
</template> 

<script>
import Navbar from './components/Navbar'
import Pnavbar from './components/pnavbar'

export default {
  name:'App',
  components:{ Navbar,Pnavbar },
  data(){
    return{
        offs:false,
        showone:true,
        showtwo:false,
        isActive:false,
        d1: false
    }
  },
  methods:{
      clickHome:function(){
      this.$router.push({path:'/'});
      this.$store.state.d5 = !this.$store.state.d5;
      document.body.scrollTop = 0;   /*如果没有这个移动端就没有回到顶部 */
      document.documentElement.scrollTop = 0;
    },
    clickHardone:function(){
      this.$router.push({path:'/hard'});
      this.$store.state.d5 = !this.$store.state.d5;
      document.body.scrollTop = 0;
       document.documentElement.scrollTop = 0;
    },
    clickHardtwo:function(){
      this.$router.push({path:'/hard/hardtwo'});
      this.$store.state.d5 = !this.$store.state.d5;
      document.body.scrollTop = 0;
       document.documentElement.scrollTop = 0;
    },
    clickSoft:function(){
      this.$router.push({path:'/software'});
      this.$store.state.d5 = !this.$store.state.d5;
      document.body.scrollTop = 0;
       document.documentElement.scrollTop = 0;
    },
    clickCase:function(){
      this.$router.push({path:'/cooperation'});
      this.$store.state.d5 = !this.$store.state.d5;
      document.body.scrollTop = 0;
       document.documentElement.scrollTop = 0;
    },
    clickAbout:function(){
      this.$router.push({path:'/about'});
      this.$store.state.d5 = !this.$store.state.d5;
      document.body.scrollTop = 0;
       document.documentElement.scrollTop = 0;
    },
    clickLog:function(){
      this.$router.push({path:'/log'});
      this.$store.state.d2 = true;
      this.$store.state.d5 = !this.$store.state.d5;
      document.body.scrollTop = 0;
       document.documentElement.scrollTop = 0;
    },
    phonelogo(){
      this.$router.push({path:'/'});
    },
    clickEgVersion(e){
      window.location.href = e
      this.$store.state.d5 = !this.$store.state.d5;
    },
    hardPro(){
      this.showone = !this.showone;
      this.showtwo = !this.showtwo;
      this.isActive = !this.isActive;
    },
    off1(){
      this.$store.state.d5 = !this.$store.state.d5;
      this.$store.state.d6.style.display = 'block';
    },
    off2(){
      this.$store.state.d5 = !this.$store.state.d5;
    },
  },
 
  watch: {
    $route (to,from){
      this.d1 = to.name === 'home'
    }
  },
   mounted(){
    this.$store.state.d6 = this.$refs.divup;
    var width = window.innerWidth || document.body.innerWidth || document.body.scrollWidth;
    if(width < 768){
        this.$store.state.d2 = true;
    }
  }
}

</script>

<style>
*::-webkit-scrollbar{
  display: none;
}

html {
    -ms-overflow-style:none;
    overflow:-moz-scrollbars-none;
    /* overflow: hidden; */
    overflow:-moz-scrollbars-vertical; /*Always show Firefox scrollbar*/
}
body img
{
   -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
html::-webkit-scrollbar{width:0px}
*{
  margin: 0 ;
  padding: 0;
}
#app {
  font-family: 微软雅黑, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
ul {
  list-style-type: none;
}
a{
  text-decoration: none;
  color: #333;
}
html, body {
    width: 100%;
    height: 100%;
    }
body {
    font-family: 微软雅黑,Helvetica Neue, Helvetica, Arial, sans-serif;

}
/* .header .nav>li:nth-child(7) a{
  color: #fff;
}
.header .nav>li:nth-child(7) a:hover{
  color: #fff;
} */

/* .swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{
  margin: 15px 0;
  background: #333;
  opacity: 1;
}
.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets .swiper-pagination-bullet-active{
  background: #007aff;
  opacity: 1;
} */

.header.d1 .nav>li>a,
.swiper-wrapper.d1 .section .footer p,
.header.d1 .head_opt .fa.fa-bars,
.header.d5 .head_opt .fa.fa-bars,
.header.d1 .nav>li.spec a,
.header.d1 .fa.fa-caret-down,
.header.d5 .fa.fa-caret-down,
.header.d1 .nav li.books .book a,
.header.d5 .nav li.books .book a
{
  color:#fff;
}

.header.d1 .fa.fa-bars:hover,.header.d5 .fa.fa-bars:hover{
  color:#198bfe;
}
.header.d5 .nav>li>a,
.header.d5 .nav>li.spec a,
.swiper-wrapper.d5 .section .footer p{
  color:#fff;
}
.header.d1 .section_header .logo, .header.d5 .section_header .logo{
  background: url(./assets/logo-white.png);
    background-size: 100% 100%;
    width: 119px;
    height: 24px;
}

.swiper-pagination.d1,.swiper-pagination.d2,.swiper-pagination.d3,.swiper-pagination.d4,.swiper-pagination.d5{
  right: 66px;
  position: fixed;
  z-index: 99;
  bottom: 424px;
  height: 150px;
}
.swiper-pagination .swiper-pagination-bullet{
  width: 10px;
	height: 10px;
  margin-bottom: 20px;
  display: block;
  border-radius: 50%;
  cursor: pointer;
}

.swiper-pagination.d5 .swiper-pagination-bullet,.swiper-pagination.d1 .swiper-pagination-bullet {
    background: #fff;
    opacity: 1;
}

.swiper-pagination.d1 .swiper-pagination-bullet.swiper-pagination-bullet-active,.swiper-pagination.d5 .swiper-pagination-bullet.swiper-pagination-bullet-active{
    background: #007aff;
}
.swiper-pagination.d2 .swiper-pagination-bullet,
.swiper-pagination.d3 .swiper-pagination-bullet,
.swiper-pagination.d4 .swiper-pagination-bullet
{
  background: #333;
  opacity: 1;
}
.swiper-pagination.d2 .swiper-pagination-bullet.swiper-pagination-bullet-active,
.swiper-pagination.d3 .swiper-pagination-bullet.swiper-pagination-bullet-active,
.swiper-pagination.d4 .swiper-pagination-bullet.swiper-pagination-bullet-active{
   background: #007aff;
}
@media screen and (max-height: 800px){
.swiper-pagination.d1,.swiper-pagination.d2,.swiper-pagination.d3,.swiper-pagination.d4,.swiper-pagination.d5{
  top:27%;
  bottom: 0px;
}
}
/* 合作案例的导航栏 */
.home .header .nav>li>a,
.home .header .nav>li.books .book a{
    color: #fff;
}
.home .header .fa.fa-bars,
.home .header .fa.fa-caret-down{
    color: #fff;
}
.home .header .section_header .logo{
    background: url(./assets/logo-white.png) no-repeat;
    background-size: 100% 100%;
    width: 119px;
    height: 24px;
    margin-left: 50px;
}
/* 关于我们导航栏 */
/* .about .header .nav li a{
    color: #fff;
}
.about .header .fa.fa-bars{
    color: #fff;
}
.about .header .section_header .logo{
    background: url(./assets/logo-white.png) no-repeat;
    background-size: 100%;
    width: 119px;
    height: 24px;
    margin-left: 50px;
} */
/* 底部导航 */
.foots .nav li a:hover{
    color: #198bfe;
}
.function .port .more{
    display: none;
}
.function .port .mains{
  position: relative;
  top: 0;
}
.function .port .section{
  background: none;
  z-index: 0;
}

/*手机*/
@media screen and (min-width:768px){
  .pheader{
    display: none;
  }
}
@media screen and (max-width:768px){
    .pheader{
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
}
.pheader .section_header .phone-logo{
  background: url(./assets/phone/logo.svg) no-repeat;
    background-size: cover;
    width: 20px;
    height: 20px;
}
.section_header{
  background: #000 ;
  width: 100%;
  height: 48px;
  display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
    box-sizing: border-box;
}
.pheader .phone-bar{
  display: block;
  background: url(./assets/phone/menu.svg) no-repeat;
  background-size: cover;
  width: 20px;
  height: 20px;
}
.closes{
    width: 100%;
    height: 100vh;
  transition: all 0.3s linear;
   background: #000;
   position: fixed;
   top: 0;
   left: 0;
   transform: translateY(-200%);
  }
  .closes.push{
    z-index: 9;
    transform: translateY(0);
}
  .closes .close{
    width: 100%;
    height: 48px;
    padding: 0px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .close img{
    width: 15px;
	  height: 15px;
  }
  .nav1{
    width:100%;
    display: block;
    margin-top: 25px;
    /* transition-delay: 0s; */
  }
  .nav1 li{
    display: flex;
    justify-content: center;
  }
  .write a{
    color:#FFF;
    font-size: 13px;
    letter-spacing: 1px;
  }
  .write a.active{
    color: #198bfe;
  }
  .nav1 li .menu{
    width: 80%;
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #333;
  }
.nav1 li .menu .icon{
  background: url(./assets/phone/more_right.svg) no-repeat;
  background-size: cover;
  width: 5px;
	height: 9px;
}
.nav1 li .menu .icon1{
  background: url(./assets/phone/more_bottom.svg) no-repeat;
  background-size: cover;
  width: 10px;
  height: 5px;
}
.nav1 .twohard{
  width: 100%;
  height: 90px;
}
}

/* 软件服务的更多功能 */
@media screen and (max-height: 800px){
.contents .function .port .section .mains{
    transform: scale(1);
}
}


</style>



// WEBPACK FOOTER //
// src/App.vue